class UpdatePathDataTableDetailResult {
    Id: number;
    IsPublished: boolean;

    constructor(id: number, isPublished: boolean) {
        this.Id = id;
        this.IsPublished = isPublished;
    }
}

export default UpdatePathDataTableDetailResult;
